import script from "./AdminJsonTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminJsonTextarea.vue?vue&type=script&setup=true&lang=js"

import "./AdminJsonTextarea.vue?vue&type=style&index=0&id=b91554d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b91554d2"]])

export default __exports__